'use client'

import * as React from 'react'
import { Sine, gsap } from 'gsap'

import { useGsapContext } from './use-gsap-context'

const defaultOptions = {
  randomRadius: { min: 10, max: 30 },
  duration: 3,
  initialFadeIn: { enabled: true, duration: 1.5 },
}

export const useFloatingBubblesAnimation = (options?: {
  randomRadius?: { min: number; max: number }
  duration?: number
  initialFadeIn?: { enabled: boolean; duration: number }
}) => {
  const [target, setTarget] = React.useState<gsap.TweenTarget>(null)

  useGsapContext(() => {
    if (!target) return

    const radius = `random(${
      options?.randomRadius?.min ?? defaultOptions.randomRadius.min
    }, ${options?.randomRadius?.max ?? defaultOptions.randomRadius.max}, 1)`
    const duration = options?.duration ?? defaultOptions.duration

    gsap.set(target, {
      xPercent: -50,
      yPercent: -50,
      x: -radius,
      y: -radius,
    })

    const initialFadeIn = options?.initialFadeIn ?? defaultOptions.initialFadeIn
    if (initialFadeIn.enabled) {
      gsap.to(target, { autoAlpha: 1, duration: initialFadeIn.duration })
    }

    gsap.to(target, {
      duration,
      y: radius,
      ease: Sine.easeInOut,
      repeat: -1,
      yoyo: true,
    })

    gsap
      .to(target, {
        duration,
        x: radius,
        ease: Sine.easeInOut,
        repeat: -1,
        yoyo: true,
      })
      .progress(0.5)
  }, [
    target,
    options?.randomRadius?.min,
    options?.randomRadius?.max,
    options?.duration,
    options?.initialFadeIn,
  ])

  return { setTarget }
}
